import { html } from 'lit';

export const iconCheckbox = html`
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect
      x="1"
      y="1"
      width="18"
      height="18"
      rx="3"
      fill="white"
      stroke="currentColor"
      stroke-width="2"
    />
  </svg>
`;
